import React, { useEffect } from 'react'
import Breadcrumbs from '@mui/material/Breadcrumbs';
import { Link, useNavigate, useParams } from 'react-router-dom'
import { get, isEmpty } from "lodash";
import { MdNavigateNext } from 'react-icons/md'
import Swal from "sweetalert2";
import { Button, Checkbox, Container, FormControlLabel, Grid, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, InputLabel } from '@mui/material';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { AiFillCloseCircle } from 'react-icons/ai';
import { useSelector, useDispatch } from 'react-redux'
import { setEditQuestion, stateRefresh, stateValues } from '../../slices/inPlaySlice';
import axios from 'axios'
import moment from 'moment'
import Paper from '@mui/material/Paper';
import Skelton from '../../common/Skelton';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { PREDICTION, PREDICTION_CANCEL, PREDICTION_CHANGE_STATUS, PREDICTION_DISTRIBUTE_WINNING, PREDICTION_FORCE_CANCEL, PREDICTION_WINNING_SET } from '../../constant/endpoint';
import { useStyles } from '../../constant/constant';
import PredictionNvigation from '../../components/PredictionNvigation';
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    height: '95%',
    transform: 'translate(-50%, -50%)',
    width: 500,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
    padding: '0px 30px',
    overflow: "auto",
    paddingBottom: "20px"
};
const styleAnswer = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    height: '30%',
    transform: 'translate(-50%, -50%)',
    width: 500,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
    padding: '0px 30px',
    overflow: "auto",
    paddingBottom: "20px"
};


const Poll = () => {
    const { match_id, series_id, sport } = useParams()
    const dispatch = useDispatch();
    const predictionState = useSelector((state) => state.prediction);
    const [open, setOpen] = React.useState(false);
    const [checkAnswerState, setCheckAnswerState] = React.useState(false);
    const [answerConfirm, setAnswerConfirm] = React.useState({});
    const [predictionList, setPrediction] = React.useState([]);
    const [imageofQustion, setImageofQustion] = React.useState(undefined);
    const [value, setValue] = React.useState('1');
    const [crossCheckState, setCrossCheckState] = React.useState([]);
    const [Loading, setLoading] = React.useState(true);
    const [sort, setSort] = React.useState({});
    const [apiWork, setApiWork] = React.useState(false)
    const navigate = useNavigate();
    const classes = useStyles();

    const handleChange = (event, newValue) => {
        setValue(newValue);
    }
    const imageFile = (e) => {
        const file = e.target.files[0]
        setImageofQustion(file)
    }
    const handleOpen = () => {
        setOpen(true)
        dispatch(stateRefresh())
        setApiWork(false)
        dispatch(stateValues({ name: 'predic_start_time', value: `${moment().format("YYYY-MM-DD")}T${moment().format("HH:mm")}` }))
    };
    const handleClose = () => setOpen(false);
    const handleAnswerClose = () => setCheckAnswerState(false);
    useEffect(() => {
        if (isEmpty(predictionList) && Loading) {
            getOpinionTrading()
        }
    })

    const getOpinionTrading = async () => {
        setLoading(true)
        const response = await axios.get(PREDICTION.replace(':match_id', match_id).replace(':series_id', series_id))
        if (response?.data?.status === 'success' && !isEmpty(response?.data?.data) && !isEmpty(response?.data?.data.filter((data) => !data.is_subjective))) {
            setPrediction(response?.data?.data.filter((data) => !data.is_subjective))
        }
        setLoading(false)
    }


    const setQuestion = (e) => {
        dispatch(stateValues({ name: e.target.name, value: e.target.value }))
    }
    const removeOption = (index) => {
        const options = predictionState.questionStates.option.filter((data, i) => i !== index)
        dispatch(stateValues({ name: 'option', value: options }))
    }
    const selectCorrectAnswer = (e) => {
        const option = predictionState.questionStates.option.map(data => data.id === Number(e.target.value) ? { ...data, isCorrect: true } : { ...data, isCorrect: false })
        dispatch(stateValues({ name: 'option', value: option }))
    }
    const selectCrossCheckCorrectAnswer = (e) => {
        const option = predictionState.questionStates.option.map(data => data.id === Number(e.target.value) ? { ...data, isCorrect: true } : { ...data, isCorrect: false })
        setCrossCheckState(option)
    }
    const addOptionFiled = () => {
        if (!isEmpty(predictionState.questionStates.question_english)) {
            dispatch(stateValues({ name: 'option', value: [...predictionState.questionStates.option, { option: '', isCorrect: false, }] }))
        } else {
            getSweetAlert('error', 'fill Question in English field')
        }
    }


    // Alert Function
    const getSweetAlert = (type, topic) => {
        Swal.fire({
            position: 'top-end',
            icon: type,
            title: topic,
            showConfirmButton: false,
            timer: 3000
        })
    }

    const setOption = (e, index) => {
        const { name, value } = e.target;
        const selectedOption = predictionState.questionStates.option.find((data, i) => i === index)
        let option = [...predictionState.questionStates.option]
        const data = {
            ...selectedOption,
            id: index + 1,
        }
        data[name] = value
        option[index] = data
        dispatch(stateValues({ name: 'option', value: option }))
    }

    const submit = async () => {
        if (IsValidation()) {
            await submitQuestion()
        }
    }

    const submitQuestion = async () => {
        setApiWork(true)
        const formData = new FormData()
        let data = {
            ...predictionState.questionStates,
            match_id,
            series_id,
            predic_start_time: moment(predictionState.questionStates.predic_start_time).utc().format(),
            predic_end_time: moment(predictionState.questionStates.predic_end_time).utc().format(),
        }

        formData.append('image', imageofQustion);
        delete data.status
        formData.append('data', JSON.stringify(data));
        let result;
        if (predictionState.questionStates.isEdit) {
            result = await axios.patch(PREDICTION.replace(':match_id', match_id).replace(':series_id', series_id), formData)
        } else {
            result = await axios.post(PREDICTION.replace(':match_id', match_id).replace(':series_id', series_id), formData)
        }

        if (result?.data?.status === 'success') {
            setApiWork(false)
            if (!predictionState.isEdit) {
                Swal.fire({
                    position: 'top-end',
                    icon: 'success',
                    title: 'Question Successfully Added',
                    showConfirmButton: false,
                    timer: 1500
                })
            } else {
                Swal.fire({
                    position: 'top-end',
                    icon: 'success',
                    title: 'Question Successfully Edit',
                    showConfirmButton: false,
                    timer: 1500
                })
            }
        }
        getOpinionTrading()
        handleClose()
    }
    const IsValidation = () => {
        let status = true
        const data = predictionState.questionStates
        if (isEmpty(data.question_english)) {
            status = false
            getSweetAlert('error', 'Enter the question')
        } else if (!(data.entry_fee > 0)) {
            status = false
            getSweetAlert('error', 'Entry Free  Required')
        } else if (data.slots_per_user <= 0) {
            status = false
            getSweetAlert('error', 'Enter Slot Per user')
        }
        else if (isEmpty(data.predic_start_time)) {
            status = false
            getSweetAlert('error', 'Start Time Must Be More Than Present Time')

        } else if (isEmpty(data.predic_end_time) || (moment(data.predic_end_time).format("YYYY-MM-DD, HH:mm") < moment(data.predic_start_time).format("YYYY-MM-DD, HH:mm"))) {
            status = false
            getSweetAlert('error', 'End Time Must be Larger Than Start Time')
        } else if (Number(data.slots_per_user) >= Number(data.slots)) {
            status = false
            getSweetAlert('error', 'User Slot Not More Than Total Slots')
        } else if (Number(data.admin_commission) < 10) {
            status = false
            getSweetAlert('error', 'Admin Commission Not Less Than 10')
        } else if ((data.option.some(data => isEmpty(data.option)) || data.option.length < 2)) {
            status = false
            getSweetAlert('error', 'Option must be Filled and minimum two option required')
        } else if (getPollsOptionCheck(data)) {
            status = false
            getSweetAlert('error', 'option must be diffrent')
        }
        return status
    }
    const getPollsOptionCheck = (data) => {
        const option = data.option
        const oldArr = []
        option.map((item) => oldArr.push(item.option))
        var unique = [...new Set(oldArr)]
        function arrayEquals(a, b) {
            return Array.isArray(unique) &&
                Array.isArray(b) &&
                a.length === b.length &&
                a.every((val, index) => val === b[index]);
        }
        return !arrayEquals(oldArr, unique)
    }
    const editQuestion = (data) => {
        setOpen(true)
        const inPlayData = {
            ...data,
            predic_start_time: `${moment(data.predic_start_time).format(
                "YYYY-MM-DD"
            )}T${moment(data.predic_start_time).format("HH:mm")}`,
            predic_end_time: `${moment(data.predic_end_time).format(
                "YYYY-MM-DD"
            )}T${moment(data.predic_end_time).format("HH:mm")}`,
            isEdit: true,
        };
        dispatch(setEditQuestion(inPlayData));
        getOpinionTrading()
    }
    const breadcrumbs = [
        <Link underline="hover" key="1" color="inherit" to={'/matchlist'} >
            <h4>Matchlist</h4>
        </Link>, <Link
            underline="hover"
            color="inherit"
        >
            Prediction
        </Link>, <h5>{'Poll'}</h5>
    ];
    const questionStatus = async (status, prediction_id) => {
        let data;
        if (status) {
            data = { status: 0, match_id, series_id }
        } else {
            data = { status: 1, match_id, series_id }
        }
        await axios.patch(PREDICTION_CHANGE_STATUS.replace(':prediction_id', prediction_id), data)
        getOpinionTrading()
    }
    const predictionCancel = async (data, status, prediction_id) => {
        const answer = data.option.filter(x => x.isCorrect)[0].option
        let optionObj = {
            "Select answer": "Select answer"
        };
        for (var obj of data.option) {
            optionObj[obj.option] = obj.option
        }
        Swal.fire({
            title: 'Confirm Your Answer',
            input: 'select',
            inputOptions: optionObj,
            inputAttributes: {
                autocapitalize: 'off'
            },
            showCancelButton: true,
            confirmButtonText: 'Cancel The Match',
            showLoaderOnConfirm: true,

            preConfirm: async (login) => {
                if (login.trim() !== answer.trim()) {
                    getSweetAlert('error', 'Please Correct Answer')
                } else {
                    await axios.patch(PREDICTION_CANCEL.replace(':prediction_id', prediction_id))
                    getOpinionTrading()
                }
            }
        })
    }
    const setWinning = async (data) => {
        const resultCheck = await Swal.fire({
            title: `Do you want Winning set?`,
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No'
        })
        if (resultCheck.isConfirmed) {
            Swal.fire({
                title: 'Wait !',
                text: 'While We are setting the winning',
                imageUrl: 'https://cdn.dribbble.com/users/164889/screenshots/1192618/loading-red-spot.gif',
                imageWidth: 400,
                imageHeight: 200,
                imageAlt: 'Custom image',
                showConfirmButton: false,
                allowOutsideClick: false
            })
            const result = await axios.post(
                PREDICTION_WINNING_SET,
                data
            );
            if (result?.data?.status === "success") {
                getOpinionTrading()
                Swal.close()
                Swal.fire({
                    position: "top-end",
                    icon: "success",
                    title: "Winning set successfully",
                    showConfirmButton: false,
                    timer: 1500,
                });
            }
        }
    };
    const winningDistribution = async (id) => {
        const resultCheck = await Swal.fire({
            title: `Do you want Winning Distribute?`,
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No'
        })
        if (resultCheck.isConfirmed) {
            Swal.fire({
                title: 'Wait !',
                text: 'While We are distributing the winning',
                imageUrl: 'https://cdn.dribbble.com/users/164889/screenshots/1192618/loading-red-spot.gif',
                imageWidth: 400,
                imageHeight: 200,
                imageAlt: 'Custom image',
                showConfirmButton: false,
                allowOutsideClick: false
            })
            const result = await axios.patch(
                PREDICTION_DISTRIBUTE_WINNING.replace(':id', id)
            );
            if (result?.data?.status === 'success') {
                getOpinionTrading()
                Swal.close()
                Swal.fire({
                    position: "top-end",
                    icon: "success",
                    title: "Winning Distribution successfully",
                    showConfirmButton: false,
                    timer: 1500,
                });
            }
        }
    };
    const forceCancelPrediction = async (prediction_id) => {
        const result = await Swal.fire({
            title: 'Do you want to cancel the prediction ?',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No'
        })
        if (result.isConfirmed) {
            const result = await axios.patch(
                PREDICTION_FORCE_CANCEL.replace(':prediction_id', prediction_id)
            );
            if (result?.data?.status === 'success') {
                getOpinionTrading()
                Swal.fire({
                    position: "top-end",
                    icon: "success",
                    title: "Prediction Cancel successfully",
                    showConfirmButton: false,
                    timer: 1500,
                });
            }
        }
    }
    const checkData = (data) => {
        let finishData;
        let InPlayData;
        finishData = predictionList.filter((data) => data.is_finish)
        InPlayData = predictionList.filter((data) => !data.is_finish)
        if (data === 'live') {
            return InPlayData
        } else if (data === 'finish') {
            return finishData
        }
    }
    const handleShorting = async (data) => {
        const predictionData = {
            ...data,
            predic_start_time: `${moment(data.predic_start_time).format(
                "YYYY-MM-DD"
            )}T${moment(data.predic_start_time).format("HH:mm")}`,
            predic_end_time: `${moment(data.predic_end_time).format(
                "YYYY-MM-DD"
            )}T${moment(data.predic_end_time).format("HH:mm")}`,
            sort_number: sort[data._id]?.sort_number ? sort[data._id]?.sort_number : data.sort_number
        };
        delete predictionData.status
        let result = await axios.patch(PREDICTION.replace(':match_id', match_id).replace(':series_id', series_id), { data: JSON.stringify(predictionData) })
        if (result?.data?.status === 'success') {
            if (!predictionState.isEdit) {
                Swal.fire({
                    position: 'top-end',
                    icon: 'success',
                    title: 'Sorting Successfully Added.',
                    showConfirmButton: false,
                    timer: 1500
                })
            } else {
                Swal.fire({
                    position: 'top-end',
                    icon: 'success',
                    title: 'Sort Add Successfully',
                    showConfirmButton: false,
                    timer: 1500
                })
            }
        }
        getOpinionTrading()
    }

    const handleSortingInput = (e, id) => {
        if (e.target.value) {
            setSort(prevValue => ({ ...prevValue, [id]: { sort_number: e.target.value } }))
        }
    }

    // const checkAnswer = (data) => {
    //     const pollData = {
    //         ...data,
    //         predic_start_time: `${moment(data.predic_start_time).format(
    //             "YYYY-MM-DD"
    //         )}T${moment(data.predic_start_time).format("HH:mm")}`,
    //         predic_end_time: `${moment(data.predic_end_time).format(
    //             "YYYY-MM-DD"
    //         )}T${moment(data.predic_end_time).format("HH:mm")}`,
    //         isEdit: true,
    //     };
    //     dispatch(setEditQuestion(pollData));
    //     setCheckAnswerState(true)
    // }

    const submitAnswer = () => {
        const currentAnswer = predictionState.questionStates.option.filter(x => x.isCorrect)
        console.log(predictionState.questionStates._id);
        const confirmAnswer = crossCheckState.filter(x => x.isCorrect)
        if (confirmAnswer[0]?.id !== currentAnswer[0]?.id) {
            getSweetAlert('error', 'Answer does not match')
        } else {
            setAnswerConfirm(predictionState.questionStates._id)
            setCheckAnswerState(false)
        }
    }
    const RedirectFun = (match_id, series_id, name) => {
        navigate(`/matchlist/${name}/${match_id}/${series_id}`)
    }
    return (
        <>
            <div className="homeCard">
                <div className='subHomeCard'>
                    <Breadcrumbs
                        separator={<MdNavigateNext fontSize="small" />}
                        aria-label="breadcrumb"
                    >

                        {breadcrumbs}
                    </Breadcrumbs>
                    <div>
                        <Container maxWidth="xl">
                            <Grid container style={{ display: "flex", justifyContent: "space-between", paddingBottom: "20px", borderBottom: "1px solid #ccc" }}>
                                <Grid item spacing={3}>
                                    <Stack spacing={{ xs: 1, sm: 2 }} direction="row" useFlexGap flexWrap="wrap" mt={2}>
                                        <Button variant={'contained'} color="primary" onClick={() => handleOpen()}>Add Questions</Button>
                                    </Stack>
                                </Grid>
                                <Grid item>
                                    <Grid container style={{ display: "flex", justifyContent: "flex-end", paddingBottom: "20px", }}>
                                        <PredictionNvigation match_id={match_id} series_id={series_id} sport={sport} />
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Container>
                    </div>
                    <Box sx={{ width: '100%', typography: 'body1' }}>
                        <TabContext value={value}>
                            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                <TabList onChange={handleChange} aria-label="lab API tabs example">
                                    <Tab label="LIVE" value="1" />
                                    <Tab label="RESULT" value="2" />
                                    {/* <Tab label="Move to Finish" value="2" /> */}
                                </TabList>
                            </Box>
                            <TabPanel style={{ padding: "0px" }} value="1">
                                <TableContainer component={Paper} style={{ margin: "30px 0px" }}>
                                    <Table className={classes.table} sx={{ minWidth: 900 }} aria-label="simple table" style={{ width: "100%", tableLayout: "auto" }}>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>Id</TableCell>
                                                <TableCell align="left">Image</TableCell>
                                                <TableCell align="left">Question</TableCell>
                                                {/* <TableCell align="left">Slots Per User</TableCell> */}
                                                <TableCell align="center">End Time</TableCell>
                                                <TableCell align="center">Sorting</TableCell>
                                                <TableCell align="center">Edit</TableCell>
                                                <TableCell align="center">Answer</TableCell>
                                                <TableCell align="center">Status</TableCell>
                                                <TableCell align="center">Prediction</TableCell>
                                                <TableCell align="center">Winning Set</TableCell>
                                                <TableCell align="center">Info</TableCell>
                                                {/* <TableCell align="center">Force Cancel</TableCell> */}
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {predictionList.filter((data) => !(data.is_finish) && !(data.is_processing)).length > 0 ? predictionList.filter((data) => !(data.is_finish) && !(data.is_processing))?.map((data, index) => (
                                                <TableRow
                                                    key={data.name}
                                                >
                                                    <TableCell component="th" scope="row">
                                                        {index + 1}
                                                    </TableCell>
                                                    <TableCell ><img alt={data.name} style={{ width: "60px" }} src={data.image} /></TableCell>
                                                    <TableCell style={{ width: "400px" }}>{data.question_english}</TableCell>
                                                    {/* <TableCell align="center">{data.slots_per_user}</TableCell> */}
                                                    <TableCell width={100} align="center">
                                                        {moment(data.predic_end_time).format("HH:mm")} <br></br>
                                                        {moment(data.predic_end_time).format("YYYY-MM-DD")}
                                                    </TableCell>
                                                    <TableCell align="left" style={{ display: "flex", background: '#ecffe2', width: "60px" }}>
                                                        <Grid container style={{ display: "flex", background: '#fff' }}>
                                                            <TextField type='number' width={'50px'} size='small' id="outlined-basic" label="Sorting" variant="outlined" style={{ fontStyle: "8px" }} onChange={(e) => handleSortingInput(e, data._id)} autocomplete="off" value={sort[data._id]?.sort_number ? sort[data._id]?.sort_number : data.sort_number} />
                                                            <Button variant='contained' color={'warning'} style={{ fontSize: "11px", width: "60px", padding: '1px' }} onClick={() => handleShorting(data)}>Update</Button>
                                                        </Grid>
                                                    </TableCell>
                                                    {/* <TableCell align='center'>
                                                        {
                                                            data.status === 0 && data.option.some(x => x.isCorrect) ?
                                                                <Button variant={'contained'} size={'small'} color={'error'} onClick={() => checkAnswer(data)} >Check Answer</Button>
                                                                : ''
                                                        }
                                                    </TableCell> */}
                                                    <TableCell align='center'>
                                                        <Button variant={'contained'} size={'small'} color={'warning'} onClick={() => editQuestion(data)}>Edit</Button>
                                                    </TableCell>
                                                    <TableCell>
                                                        <Grid container style={{ display: "flex", background: '#fff' }}>
                                                            <p>{data?.option?.filter(x => x.isCorrect)[0]?.option}</p>
                                                        </Grid>
                                                    </TableCell>
                                                    <TableCell align='center'>
                                                        <Button variant={'contained'} size={'small'} color={data.status ? 'success' : 'error'} onClick={() => questionStatus(data.status, data._id)} >{data.status ? 'Active' : 'InActive'}</Button>
                                                    </TableCell>
                                                    <TableCell align='center'>
                                                        {
                                                            data.status === 0 && data.option.some(x => x.isCorrect) ?
                                                                <Button variant={'contained'} size={'small'} color={'error'} onClick={() => predictionCancel(data, data.status, data._id)} >Cancel</Button>
                                                                : ''
                                                        }

                                                    </TableCell>
                                                    <TableCell align='center'>
                                                        {
                                                            data.is_pred_cancel ? <Button variant={'contained'} size={'small'} color={'success'} onClick={() => setWinning(data)}>Set</Button> : ''
                                                        }
                                                        {
                                                            data.is_winning_set ? <Button style={{ margin: "5px 10px" }} variant={'contained'} size={'small'} color={'success'} onClick={() => winningDistribution(data._id)}>Distribute</Button> : ''
                                                        }
                                                    </TableCell>
                                                    <TableCell>
                                                        {
                                                            (data.pred_autocreate && data.is_prediction_full) &&
                                                            <Link style={{
                                                                outline: "none",
                                                                border: "none",
                                                                boxShadow: "0 0 2px #f49e9e",
                                                                background: "rgb(47 80 70)",
                                                                padding: "5px 10px",
                                                                color: "#fff",
                                                                fontWeight: 700,
                                                                borderRadius: 5,
                                                                fontSize: '12px'
                                                            }} to={{ pathname: `/matchlist/prediction_child/${data.match_id}/${data.series_id}/${data._id}` }}>Go</Link>
                                                        }
                                                    </TableCell>
                                                    {/* <TableCell align='center'><Button variant={'contained'} size={'small'} color={'error'} onClick={() => forceCancelPrediction(data._id)} disabled={data.status === 0 ? false : true}>Force Cancel</Button></TableCell> */}
                                                </TableRow>
                                            )) : Loading ? <Skelton /> : <TableRow><TableCell colSpan={12} style={{ textAlign: "center", padding: "10px" }}><h3>Data Not Found</h3></TableCell></TableRow>}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </TabPanel>
                            <TabPanel style={{ padding: "0px" }} value="2">
                                <TableContainer component={Paper} style={{ margin: "30px 0px" }}>
                                    <Table className={classes.table} sx={{ minWidth: 650 }} aria-label="simple table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>Id</TableCell>
                                                <TableCell align="left">Question</TableCell>
                                                <TableCell align="left">Slots Per User</TableCell>
                                                <TableCell align="center">End Time</TableCell>
                                                <TableCell align="center">View</TableCell>
                                                <TableCell align="center">Status</TableCell>
                                                <TableCell align="center">Prediction</TableCell>
                                                <TableCell align="center">Winning Set</TableCell>
                                                <TableCell align="center">Info</TableCell>
                                                {/* <TableCell align="center">Force Cancel</TableCell> */}
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {checkData('finish').length > 0 ? checkData('finish')?.map((data, index) => (
                                                <TableRow
                                                    key={data.name}
                                                >
                                                    <TableCell component="th" scope="row">
                                                        {index + 1}
                                                    </TableCell>
                                                    <TableCell>{data.question_english}</TableCell>
                                                    <TableCell align="center">{data.slots_per_user}</TableCell>
                                                    <TableCell align="center">{moment(data.predic_end_time).format("HH:mm")} {moment(data.predic_end_time).format("YYYY-MM-DD")}</TableCell>
                                                    <TableCell align='center'><Button variant={'contained'} size={'small'} color={'warning'} onClick={() => editQuestion(data)}>View</Button></TableCell>
                                                    <TableCell align='center'>
                                                        <Button variant={'contained'} size={'small'} color={data.status ? 'success' : 'error'} onClick={() => questionStatus(data.status, data._id)} disabled>{data.status ? 'Active' : 'InActive'}</Button>
                                                    </TableCell>
                                                    <TableCell align='center'>
                                                        <Button variant={'contained'} size={'small'} color={'error'} onClick={() => predictionCancel(data.status, data._id)} disabled >Cancel</Button>
                                                    </TableCell>
                                                    <TableCell align='center'>
                                                        {
                                                            data.is_pred_cancel ? <Button variant={'contained'} size={'small'} color={'success'} onClick={() => setWinning(data)} disabled>Set</Button> : ''
                                                        }
                                                        {
                                                            data.is_winning_set ? <Button style={{ margin: "5px 10px" }} variant={'contained'} size={'small'} color={'success'} onClick={() => winningDistribution(data._id)} disabled>Distribute</Button> : ''
                                                        }
                                                    </TableCell>
                                                    <TableCell>
                                                        {
                                                            (data.pred_autocreate && data.is_prediction_full) &&
                                                            <Link style={{
                                                                outline: "none",
                                                                border: "none",
                                                                boxShadow: "0 0 2px #f49e9e",
                                                                background: "rgb(47 80 70)",
                                                                padding: "5px 10px",
                                                                color: "#fff",
                                                                fontWeight: 700,
                                                                borderRadius: 5,
                                                                fontSize: '12px'
                                                            }} to={{ pathname: `/matchlist/prediction_child/${data.match_id}/${data.series_id}/${data._id}` }}>Go</Link>
                                                        }
                                                    </TableCell>
                                                    {/* <TableCell align='center'><Button variant={'contained'} size={'small'} color={'error'} onClick={() => forceCancelPrediction(data._id)} disabled={data.win_distribute}>Force Cancel</Button></TableCell> */}
                                                </TableRow>
                                            )) : Loading ? <Skelton /> : <TableRow><TableCell colSpan={12} style={{ textAlign: "center", padding: "10px" }}><h3>Data Not Found</h3></TableCell></TableRow>}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </TabPanel>
                        </TabContext>
                    </Box>
                </div>

            </div>

            <Modal
                open={open}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                onBackdropClick={() => setOpen(true)}
            >
                <Box sx={style} spacing={0.5} direction="row" useFlexGap flexWrap="wrap">
                    <Grid container>
                        <Grid xs={11}>
                            <h2 id="modal-title" mb={1}>{'Poll'}  Questions</h2>
                        </Grid>
                        <Grid xs={1}>
                            <Button onClick={handleClose}><AiFillCloseCircle style={{ width: "25px", height: "40px" }} /></Button>
                        </Grid>
                        <h4> {predictionState.questionStates._id && 'Pred id-'}  {predictionState?.questionStates?._id}</h4>
                    </Grid>
                    <hr />
                    <Grid container spacing={1}>
                        <Grid xs={4} item>
                            <label>Entry Fee</label>
                            <TextField id="outlined-basic" type='number' size={'small'} variant="outlined" name={'entry_fee'} onChange={setQuestion} value={predictionState.questionStates.entry_fee} disabled={get(predictionState, "questionStates.status") === undefined ? false : true} />
                        </Grid>
                        <Grid xs={4} item>
                            <label>Total Slots</label>
                            <TextField id="outlined-basic" type='number' size={'small'} variant="outlined" name={'slots'} onChange={setQuestion} value={predictionState.questionStates.slots} disabled={get(predictionState, "questionStates.status") === undefined ? false : true} />
                        </Grid>
                        <Grid xs={4} item>
                            <label>Slots Per User</label>
                            <TextField id="outlined-basic" type='number' size={'small'} variant="outlined" name={'slots_per_user'} onChange={setQuestion} value={predictionState.questionStates.slots_per_user} disabled={get(predictionState, "questionStates.status") === undefined ? false : true} />
                        </Grid>
                        <Grid xs={6} item>
                            <label>Admin Per Commission</label>
                            <TextField id="outlined-basic" type='number' size={'small'} variant="outlined" name={'admin_commission'} onChange={setQuestion} value={predictionState.questionStates.admin_commission} disabled={get(predictionState, "questionStates.status") === undefined ? false : true} />
                        </Grid>
                        <Grid container ml={1} mt={1}>
                            <Grid xs={6} item>
                                <label>Start Date and Time</label>
                                <TextField type='datetime-local' id="outlined-basic" size={'small'} variant="outlined" name={'predic_start_time'} value={predictionState.questionStates.predic_start_time} onChange={setQuestion} disabled={get(predictionState, "questionStates.status") === undefined ? false : true} />
                            </Grid>
                            <Grid xs={6} item>
                                <label>End Date and Time</label>
                                <TextField type='datetime-local' id="outlined-basic" size={'small'} variant="outlined" name={'predic_end_time'} value={predictionState.questionStates.predic_end_time} onChange={setQuestion} disabled={get(predictionState, "questionStates.is_finish")} />
                            </Grid>
                        </Grid>
                        <Grid xs={6}>

                            <FormControlLabel control={<Checkbox id='pred_confirm' checked={JSON.parse(predictionState.questionStates.pred_confirm)} value={!JSON.parse(predictionState.questionStates.pred_confirm)} type='checkbox' placeholder='Entry Fee' name='pred_confirm' onChange={setQuestion} disabled={get(predictionState, "questionStates.status") === undefined ? false : true} ></Checkbox>} label="Prediction Confirm" />
                        </Grid>
                        <Grid xs={6}>
                            <FormControlLabel control={<Checkbox id='pred_autocreate' checked={JSON.parse(predictionState.questionStates.pred_autocreate)} value={!JSON.parse(predictionState.questionStates.pred_autocreate)} type='checkbox' name='pred_autocreate' onChange={setQuestion} disabled={get(predictionState, "questionStates.status") === undefined ? false : true} />} label="Prediction Autocreate" />
                        </Grid>
                        <Grid xs={12} item mt={1}>
                            <label>Write Question in English</label>
                            <TextField fullWidth id="standard-basic" size={'small'} placeholder="Write Question in English" name={'question_english'} value={predictionState.questionStates.question_english} variant="outlined" onChange={setQuestion} disabled={get(predictionState, "questionStates.is_finish") || get(predictionState, "questionStates.status") === 1} />
                        </Grid>
                        <Grid xs={12} item mt={1}>
                            <label>Write Question in Hindi</label>
                            <TextField fullWidth id="standard-basic" size={'small'} placeholder="सवाल हिंदी में लिखें ?" name={'question_hindi'} value={predictionState.questionStates.question_hindi} variant="outlined" onChange={setQuestion} disabled={get(predictionState, "questionStates.is_finish") || get(predictionState, "questionStates.status") === 1} />
                        </Grid>

                        {predictionState.questionStates.option.map((data, index) =>
                            <Grid container mt={1} item spacing={1}>
                                <Grid item xs={10}>
                                    <TextField fullWidth size={'small'} placeholder={`option ${index + 1}`} value={data.option} name={'option'} onChange={(e) => setOption(e, index)} disabled={get(predictionState, "questionStates.status") === undefined ? false : true} />
                                </Grid>
                                <Grid item xs={2}>
                                    <Button style={{ height: "100%" }} size="small" variant="outlined" color='error' onClick={() => removeOption(index)} disabled={get(predictionState, "questionStates.status") === undefined ? false : true}>Delete</Button>
                                </Grid>
                            </Grid>
                        )}
                        <Grid item container>
                            {predictionState.questionStates.option.length < 10 && <Button variant='outlined' style={{ display: 'block', margin: '10px auto' }} onClick={addOptionFiled} disabled={get(predictionState, "questionStates.status") === undefined ? false : true}>Add Options</Button>}
                        </Grid>
                        <>
                            <Grid item container>
                                {
                                    predictionState.questionStates.isEdit ?
                                        <FormControl variant="outlined" size={'small'} sx={{ m: 1, minWidth: '100%' }}>
                                            <InputLabel id="demo-simple-select-label">Please Select Answer</InputLabel>
                                            <Select style={{ margin: '10px' }} type='select' id="demo-simple-select-label" value={get(predictionState.questionStates.option.find(data => data.isCorrect), 'id', '')} onChange={selectCorrectAnswer} disabled={predictionState.questionStates.status === 1 || predictionState.questionStates.is_finish ? true : false}>
                                                {predictionState.questionStates.option.map((data, index) =>
                                                    <MenuItem value={data.id} key={index}>{data.option}</MenuItem>
                                                )}
                                            </Select>
                                        </FormControl>
                                        : ''
                                }
                            </Grid>
                            <Grid xs={12}>
                                <input
                                    accept="image/*"
                                    id="contained-button-file"
                                    multiple
                                    type="file"
                                    onChange={imageFile}
                                />
                            </Grid>
                            <Grid xs={9} mt={2}>
                                <Button color='error' onClick={handleClose} variant="contained">Cancel</Button>
                            </Grid>
                            <Grid xs={3} mt={2} textAlign={'right'}>
                                <Button onClick={submit} variant="contained" disabled={apiWork}>Submit</Button>
                            </Grid>
                        </>
                    </Grid>
                </Box>
            </Modal>
            <Modal
                open={checkAnswerState}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                onBackdropClick={() => setCheckAnswerState(true)}
            >
                <Box sx={styleAnswer} spacing={0.5} direction="row" useFlexGap flexWrap="wrap">
                    <Grid xs={9} mt={2}>
                        <Button color='error' onClick={handleAnswerClose} variant="contained">Cancel</Button>
                    </Grid>
                    <h4>Please Confirm Answer</h4>
                    <Grid item container>
                        {
                            true ?
                                <FormControl variant="outlined" size={'small'} sx={{ m: 1, minWidth: '100%' }}>
                                    <InputLabel id="demo-simple-select-label">Please Select Answer</InputLabel>
                                    <Select style={{ margin: '10px' }} type='select' id="demo-simple-select-label" onChange={selectCrossCheckCorrectAnswer} >
                                        {predictionState.questionStates.option.map((data, index) =>
                                            <MenuItem value={data.id} key={index}>{data.option}</MenuItem>
                                        )}
                                    </Select>
                                    <Button color='success' onClick={submitAnswer} disabled={apiWork} variant="contained">Submit</Button>
                                </FormControl>
                                : ''
                        }
                    </Grid>
                </Box>
            </Modal>
        </>
    )
}

export default Poll